module.exports = __webpack_public_path__ + "img/bubble_layout_1.db478f47.jpg";